import log from 'loglevel';

import { LOG_LEVEL } from '@/config';

interface IndexableLevel extends log.LogLevel {
  [key: string]: number;
}

const logger = log.getLogger('game');
const levels = log.levels as IndexableLevel;

const level = levels[LOG_LEVEL as string] || log.levels.SILENT;

logger.setDefaultLevel(level as log.LogLevelDesc);

export default logger;
